import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Document } from './document';

@JsonObject('DocumentSearchResults')
export class DocumentSearchResults extends SearchResults {
    @JsonProperty('results', [Document])
    results: Document[] = [];
}
